<template>
  <!-- River専用 -->
  <div>
    <div class="title">
      <gl-sub-text>商品構成グラフ設定</gl-sub-text>
    </div>
    <div class="content flex">
      <div>縦軸1（棚割）：</div>
      <div>
        <md-field style="max-width: 200px">
          <md-select v-model="_y1">
            <md-option value="face">フェイス数</md-option>
            <md-option value="sku">SKU数</md-option>
          </md-select>
        </md-field>
      </div>
    </div>
    <div class="content flex">
      <div>縦軸2（実績）：</div>
      <div>
        <md-field style="max-width: 200px">
          <md-select v-model="_y2">
            <md-option value="qty">点数</md-option>
            <md-option value="amount">金額</md-option>
            <md-option value="customer_count">ID数</md-option>
          </md-select>
        </md-field>
      </div>
    </div>
    <div class="content flex">
      <div>横軸（価格帯）：</div>
      <div class="flex">
        <md-field style="max-width: 200px">
          <md-input type="number" v-model="_unitPrice" />
        </md-field>
      </div>
      <div>円刻み（最小グラフ単価）</div>
      <div>
        <md-checkbox v-model="_visibleFromMinPriceLine">
          最小グラフ単価から表示する
        </md-checkbox>
      </div>
    </div>
    <div class="title">
      <gl-sub-text>年代設定</gl-sub-text>
    </div>
    <div class="content">
      <table class="age-select">
        <colgroup>
          <col />
          <col />
          <col width="100px" />
          <col width="100px" />
        </colgroup>

        <thead>
          <tr>
            <td class="age-select__cell" rowspan="2" colspan="2"></td>
            <td class="age-select__cell" rowspan="2">集計</td>
            <td class="age-select__cell">表示</td>
          </tr>
          <tr>
            <td class="age-select__cell">年代グラフ</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(age, i) in ages" :key="age.value">
            <td v-if="i === 0" class="age-select__cell" :rowspan="ages.length">
              会員
            </td>
            <td class="age-select__cell">{{ age.name }}</td>
            <td class="age-select__cell--align-center">
              <md-checkbox
                class="age-select__check"
                v-model="_ageSummary"
                :value="age.value"
              />
            </td>
            <td class="age-select__cell--align-center">
              <md-checkbox
                class="age-select__check"
                v-model="_ageDisplay"
                :value="age.value"
                :disabled="!ageSummary.includes(age.value)"
              />
            </td>
          </tr>
          <tr>
            <td class="age-select__cell" colspan="2">非会員</td>
            <td class="age-select__cell--align-center">
              <md-checkbox
                class="age-select__check"
                v-model="_ageSummary"
                :value="''"
              />
            </td>
            <td class="age-select__cell--align-center">
              <md-checkbox
                class="age-select__check"
                v-model="_ageDisplay"
                :value="''"
                :disabled="!ageSummary.includes('')"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ErrorReport from '@/mixins/ErrorReport'

/**
 * 売場分析オプション選択コンポーネント
 */
export default {
  mixins: [ErrorReport],
  props: {
    y1: {
      type: String,
      validator: value => ['face', 'sku'].includes(value),
    },
    y2: {
      type: String,
      validator: value => ['qty', 'amount', 'customer_count'].includes(value),
    },
    unitPrice: {
      type: Number,
      validator: value => value > 0,
    },
    visibleFromMinPriceLine: {
      type: Boolean,
    },
    // 年代マスタ
    ages: {
      type: Array,
      required: true,
      default: () => [],
    },
    // 年代（集計）
    ageSummary: {
      type: Array,
    },
    // 年代（年代グラフ表示）
    ageDisplay: {
      type: Array,
    },
  },
  computed: {
    _y1: {
      get() {
        return this.y1
      },
      set(newVal) {
        this.$emit('update:y1', newVal)
      },
    },
    _y2: {
      get() {
        return this.y2
      },
      set(newVal) {
        this.$emit('update:y2', newVal)
      },
    },
    _unitPrice: {
      get() {
        return this.unitPrice
      },
      set(newVal) {
        this.$emit('update:unitPrice', parseInt(newVal, 10))
      },
    },
    _visibleFromMinPriceLine: {
      get() {
        return this.visibleFromMinPriceLine
      },
      set(newVal) {
        this.$emit('update:visibleFromMinPriceLine', newVal)
      },
    },
    _ageSummary: {
      get() {
        return this.ageSummary
      },
      set(newVal) {
        this.$emit('update:ageSummary', newVal)
        this.$emit(
          'update:ageDisplay',
          this.ageDisplay.filter(age => newVal.includes(age)),
        )
      },
    },
    _ageDisplay: {
      get() {
        return this.ageDisplay
      },
      set(newVal) {
        this.$emit('update:ageDisplay', newVal)
      },
    },
    /**
     * 入力エラー
     */
    errors() {
      const errors = []

      if (this.ageSummary.length === 0) {
        errors.push('年代設定（集計）は少なくとも１つ選択してください')
      }
      if (this.ageDisplay.length === 0) {
        errors.push('年代設定（表示）は少なくとも１つ選択してください')
      }

      return errors
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  margin-top: var(--spacing-medium);
}

.flex {
  display: flex;
  align-items: center;
}

.age-select {
  border-collapse: collapse;
  margin-top: var(--spacing-medium);

  %__cell {
    padding-left: var(--spacing-small);
    padding-right: var(--spacing-small);
    border: 1px solid;
  }

  &__cell {
    @extend %__cell;

    &--align-center {
      @extend %__cell;
      text-align: center;
    }
  }

  &__check {
    margin-top: var(--spacing-small);
    margin-bottom: 0;
    margin-left: 0;
    margin-right: 0;
  }
}
</style>
